import {
  ADD_ITEM_TO_NAVIGATION, RESET_NAVIGATION,
  RESET_MOBILE_APP_BAR, SET_MOBILE_APP_BAR
} from '../actions/types';
import { addOrReplaceChild } from '../../utils/navigationUtils';

const INITIAL_MOBILE_APP_BAR = {
  title: '',
  showBack: false,
  backText: '',
  hideBottomBar: false,
  onBack: null,
};

const INITIAL_STATE = {
  parent: null,
  children: [],
  mobileAppBar: INITIAL_MOBILE_APP_BAR
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_ITEM_TO_NAVIGATION:
      return { ...state, children: addOrReplaceChild(state.children, action.payload.children) };
    case RESET_NAVIGATION:
      return { ...state, parent: null, children: [] };

    case SET_MOBILE_APP_BAR:
      return { ...state, mobileAppBar: action.payload ?? INITIAL_MOBILE_APP_BAR };

    case RESET_MOBILE_APP_BAR:
      return { ...state, mobileAppBar: INITIAL_MOBILE_APP_BAR };

    default:
      return { ...state };
  }
}
